import { NavLink, Router, useNavigate} from 'react-router-dom';
import "./SplashPage.css";
import { GitHub, Email, LinkedIn } from '@mui/icons-material';

const githubLink = process.env.REACT_APP_GITHUB_LINK;
const linkedInLink = process.env.REACT_APP_LINKEDIN_LINK;

export default function SplashPage(props) {

  return (
    <div 
      className="splash-container"
    >

      <div
        className="sp-header"
      >
        <div
          className="sp-header-icon-container"
        >
          {/* <a
            target="_blank"
            rel="noreferrer"
            href="/contact"
          >
            <Email className='sp-header-icon' />
          </a> */}

          <a
            target="_blank"
            rel="noreferrer"
            href={githubLink}
          >
            <GitHub className='sp-header-icon' />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href={linkedInLink}
          >
            <LinkedIn className='sp-header-icon' />
          </a>
        </div>
      </div>

      <div
        className="wave-gif-container"
      >
        <img 
          src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdnl.iconscout.com%2Flottie%2Fpremium%2Fthumb%2Fwaving-hand-7901930-6308233.gif&f=1&nofb=1&ipt=076e2fb608b4dd62c10e3184d1359e1c07f3c903ee41fb7dece66bdf9fd58d3a"
          className="waving-gif"
        />
        <h1>
          Hello!  I'm Nic!
        </h1>
      </div>
      <h3>
        I'm a Software Engineer from Minneapolis, Minnesota
      </h3>

      <p>
        I have over 5 years of software development experience in enterprise web applications and video games.
      </p>

      <p>
        Visit <NavLink style={{color:"white"}} to="/resume">My Resume Page</NavLink> or the <NavLink style={{color:"white"}} to="/about">About Page</NavLink> for more information about me!  
      </p>

      {/* <p>
        I'm looking for work!  <NavLink style={{color:"white"}} to="/contact">Send Me an Email</NavLink> if you need a software developer!
      </p> */}

      {/* <p>
        You can also <NavLink style={{color:"white"}} to="/rock-paper-scissors">Play Rock Paper Scissors</NavLink> against me while you're here! :)
      </p> */}

      <div
        className="sp-header-icon-container"
      >
        {/* <a
          target="_blank"
          rel="noreferrer"
          href="/contact"
        >
          <Email className='sp-header-icon' />
        </a> */}

        <a
          target="_blank"
          rel="noreferrer"
          href={githubLink}
        >
          <GitHub className='sp-header-icon' />
        </a>

        <a
          target="_blank"
          rel="noreferrer"
          href={linkedInLink}
        >
          <LinkedIn className='sp-header-icon' />
        </a>
      </div>
    </div>
  )
}